import {
  ActionIcon,
  CloseButton,
  Group,
  Indicator,
  Modal,
} from "@mantine/core";
import { IconPlus } from "@tabler/icons-react";
import Contact from "./Contact";
import { useDisclosure } from "@mantine/hooks";
import ContactForm from "./ContactForm";
import { ContactFields } from "../../types/contact.types";
import { useState } from "react";
import { UseFormReturnType } from "@mantine/form";
import { AnyRequest, RequestBaseFields } from "../../types/request.types";
import { UserFields } from "../../types/user.types";

interface FormContactsProps<T extends AnyRequest> {
  form: UseFormReturnType<T>;
  request?: RequestBaseFields;
}

export default function FormContacts<T extends AnyRequest>({
  form,
  request
}: FormContactsProps<T>) {
  const { combined_contacts: combinedContacts } = form.values;
  let initialContacts: (ContactFields | UserFields)[] = combinedContacts || [];
  const [contacts, setContacts] = useState<(ContactFields | UserFields)[]>(initialContacts);
  const [opened, { open, close }] = useDisclosure(false);

  const onNewContact = (contact: ContactFields) => {
    const updatedContacts = [...contacts, contact];
    setContacts(updatedContacts);
    // Shouldn't need the cast here, but TS can't figure out that AnyRequest
    // will have a contacts field
    form.setFieldValue('combined_contacts', updatedContacts as any);
    close();
  }

  const onRemoveContact = (idx: number) => {
    const updatedContacts = contacts.filter((_, i) => i !== idx);
    setContacts(updatedContacts);
    form.setFieldValue('combined_contacts', updatedContacts as any);
  }
  
  return (
    <>
      <Group align="stretch">
        <Indicator
          label="Submitter"
          size={16}
          position="top-center"
          color="gray"
        >
          <Contact contact={!!request ? request.user : MtsAppVars.currentUser} />
        </Indicator>
        {contacts.map((c, idx) => (
          <Indicator
            key={idx}
            color="#ffffff00"
            label={
              <CloseButton
                size="sm"
                c="gray.2"
                bg="dark.6"
                radius="lg"
                onClick={() => onRemoveContact(idx)}
              />
            }
          >
            <Contact contact={c} cardProps={{h: '100%'}} />
          </Indicator>
        ))}
        <ActionIcon
          variant="outline"
          color="gray.7"
          radius="lg"
          title="Add contact"
          style={{alignSelf: "center"}}
          onClick={open}
        >
          <IconPlus />
        </ActionIcon>
      </Group>
      <Modal
        title="Add Contact"
        opened={opened}
        withCloseButton
        onClose={close}
        size="md"
        radius="md"
      >
        <ContactForm onSubmit={onNewContact} />
      </Modal>
    </>
  );
}